import React from 'react';
import {
	useCreateUnlayerAiEmailTemplateMutation,
	useDeleteUnlayerAiEmailTemplateMutation,
	useLazyGetUnlayerAiEmailTemplateDetailQuery,
	useLazyGetUnlayerAiEmailTemplateSummariesQuery,
	useSetActiveUnlayerAiEmailTemplateMutation,
	useShareUnlayerAiEmailTemplateMutation,
	useUpdateUnlayerAiEmailTemplateMutation,
	useUpdateUnlayerAiEmailTemplatePropertiesMutation,
} from '@/features/unlayerAiEmailTemplates/unlayerAiEmailTemplates';
import { UNLAYER_AI_EMAIL_TEMPLATE_LABELS } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/labels';
import { UnlayerTemplatesEditorProvider } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import { UnlayerTemplatesEditorView } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView';

/**
 * Tab entry point for Folio-managed AI email templates. Uses the same editor UI as
 * standard templates but adds active/share mutations from the AI templates API.
 */
export const UnlayerAiEmailTemplatesTab = () => {
	return (
		<UnlayerTemplatesEditorProvider
			options={{
				labels: UNLAYER_AI_EMAIL_TEMPLATE_LABELS,
				useLazyGetSummariesQuery: useLazyGetUnlayerAiEmailTemplateSummariesQuery,
				useLazyGetDetailQuery: useLazyGetUnlayerAiEmailTemplateDetailQuery,
				useCreateMutation: useCreateUnlayerAiEmailTemplateMutation,
				useUpdateMutation: useUpdateUnlayerAiEmailTemplateMutation,
				useDeleteMutation: useDeleteUnlayerAiEmailTemplateMutation,
				useSetActiveMutation: useSetActiveUnlayerAiEmailTemplateMutation,
				useShareMutation: useShareUnlayerAiEmailTemplateMutation,
				useUpdatePropertiesMutation: useUpdateUnlayerAiEmailTemplatePropertiesMutation,
				requireUnlayerEmailsFlag: false,
				defaultSortField: 'name',
				defaultSortDirection: 'asc',
			}}
		>
			<UnlayerTemplatesEditorView redirectWhenDisabled={false} />
		</UnlayerTemplatesEditorProvider>
	);
};
